import Vue from 'vue'

const client = () => Vue.prototype.$api

export default {
  getPatientBillingInfo () {
    return client().get('billing/patient')
  },
  savePatientBillingInfo (data) {
    return client().post('billing/patient', data)
  },
  getBillByAppointment (appointmentId) {
    return client().get(`billing/invoiceByAppointment/${appointmentId}`)
  }
}


// WEBPACK FOOTER //
// ./src/repositories/BillingRepository.js